import { createServerFn } from "@tanstack/react-start";
import { setResponseHeader } from "@tanstack/react-start/server";

/** Gate-checked public catalog; null while hidden from this viewer. Never cached across viewers. */
export const getTraumaCatalog = createServerFn({ method: "GET" }).handler(async () => {
  setResponseHeader("cache-control", "private, no-store");
  const { loadTraumaCatalog } = await import("@/lib/trauma/catalog.server");
  return loadTraumaCatalog();
});
